import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
// var db = new PouchDB("admindb");

const state = {
// country : undefined,
 search : "",
 published: undefined,
};

const mutations = {
  // setuser(state, user) {
    SET_SEARCH: (state, search) => {
    console.log(search.search, "HHHHHHHHHHHHHDFDSIFDIFDFHODFDOSFDSOFDSOF")
    state.published =  search.published ;
    state.search = search.search ;
    // state.isActive = search.isActive;
  },
 
};

const actions = {
    onSearchClick: async ({commit}, payload) => {
    console.log('hdhdhddh',payload)
    commit("SET_SEARCH", payload);
  }
};
const getters = {
    published: state => state.published,
  getsearch: state => state.search,
//   getIsActive: state => state.isActive,
  
};


// this.$store.dispatch("tickettypeStore/onSearchClick", 
//                  {country:this.filters.isCinemaSelected ,search:  this.filters.searchText,isActive:  this.filters.shown_on_frontend}
//                   // position: "Developer",
//                 );



export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
